import regEx from '../global/regEx'

export const isImagePlaceholder = (url: string) => {
  if (!url) return false
  return regEx.imagePlaceholder.test(url)
}
